import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import { useTranslation } from "react-i18next";

export const TabletLockWarning = ({
  open,
  setOpen,
  handleLockTabletMode,
}: {
  open: boolean;
  setOpen: (b: boolean) => void;
  handleLockTabletMode: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>{t('lockTabletWarningTitle')}</DialogTitle>
      <DialogContent>{t('lockTabletWarningDescription')}</DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} variant="outlined">
          {t('cancel')}
        </Button>
        <Button onClick={handleLockTabletMode}>{t('lockTablet')}</Button>
      </DialogActions>
    </Dialog>
  );
};
